/**
 *
 * GetStartedMenu
 *
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Wrapper,
  Menu,
  RightNavContent,
  Button,
  Content,
} from './styledComponents';

import Logo from 'components/Logo';

const GetStartedMenu = ({ children }) => {
  let terms = (children._owner._context.router.route.location.pathname === '/terms');
  return (
    <Wrapper>
      <Menu>
        <Logo withText={true} />
        <RightNavContent>
          {  (
          <NavLink
            style={{ fontSize: 12 }}
            activeStyle={{ display: 'none' }}
            to='/sign-up'>
            <span>Need an account?</span>
            <Button className='get-started-menu__button'>
              Sign Up
            </Button>
          </NavLink>
          )}
          <NavLink
            style={{ fontSize: 12 }}
            activeStyle={{ display: 'none' }}
            isActive={(_, {pathname: p}) => p !== '/sign-up'}
            to='/sign-in'>
            <span>Already have an account?</span>
            <Button className='get-started-menu__button'>
              Sign In
            </Button>
          </NavLink>
        </RightNavContent>
      </Menu>
      <Content divWidth={terms ? 868 : 500} >
        {children}
      </Content>
    </Wrapper>
  );
}

export default GetStartedMenu;



// WEBPACK FOOTER //
// ./src/components/GetStartedMenu/index.js